module.exports = __webpack_public_path__ + "img/footer-contact-icon-row-dark-kia.c4928f07.png";